
import React from "react";
// react library for routing
import { Route, Switch } from "react-router-dom";

// core components
import AuthNavbar from "components/Navbars/AuthNavbar.jsx";
import AuthFooter from "components/Footers/AuthFooter.jsx";

import statusRoutes from "../routes/statusPageRoutes";
import { getNewUiUrl } from "../utils/urlHelper";

class StatusPage extends React.Component {
  componentDidMount() {
    document.body.classList.add("bg-default");

    const baseUrl = getNewUiUrl();
    if (baseUrl) {
        // Redirect to the same status code in the new UI
        // Current path is usually /status/[code]
        const path = this.props.location.pathname;
        if (path.startsWith("/status/")) {
            window.location.href = baseUrl + path;
        }
    }
  }
  componentWillUnmount() {
    document.body.classList.remove("bg-default");
  }
  componentDidUpdate(e) {
    if (e.history.pathname !== e.location.pathname) {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainContent.scrollTop = 0;
    }
  }
  getRoutes = (statusRoutes) => {
    return statusRoutes.map((prop, key) => {
      if (prop.collapse) {
        return this.getRoutes(prop.views);
      }
      if (prop.layout === "/status") {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  render() {
    return (
      <>
        <div className="main-content" ref="mainContent">
          <AuthNavbar />
          <Switch>{this.getRoutes(statusRoutes)}</Switch>
        </div>
        <AuthFooter />
      </>
    );
  }
}

export default StatusPage;
